import { useState, useEffect } from 'react'
import MobileDetect from 'mobile-detect'

const useMobileDetect = () => {
  const [userAgentData, updateUserAgentData] = useState({})
  useEffect(() => {
    const md = new MobileDetect(navigator.userAgent)
    const isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1
    const isMobileBrowser = !!md.mobile() || isIpad
    const isSafari = navigator.userAgent.indexOf('Safari') > -1
    const isGonative = navigator.userAgent.indexOf('gonative') > -1
    const isFabuild = navigator.userAgent.indexOf('FABUILD') > -1
    const isAndroidOS = md.os() === 'AndroidOS'
    updateUserAgentData({
      // only actual ipad with safari is set to true. Chrome dev tool ipad will be false
      isIpad,
      isIos: md.version('iOS') || isIpad,
      isAndroidOS,
      isMobileBrowser,
      isSafari,
      isGonative,
      isFabuild,
    })
  }, [])

  return userAgentData
}

export default useMobileDetect
